import React from "react";
import {catalogQueueModel} from "./libraryFactory";
import {LibraryQueueItem} from "./LibraryQueueItem";
import {isArrayNullOrEmpty} from "../../Utilities/Types/arrayUtilities";
import {ButtonLinkStyle} from "../../Components/Inputs";

interface LibraryQueueListProps {
    handleDeselectAll?: () => void;
    handleRemoveFromQueue: (id: string, orderStatus?: string) => void;
    handleSelectAll?: () => void;
    handleSelectedItemsChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleViewOrder?: (orderId: string, catalogId: string) => void;
    heading?: string;
    queue: Record<string, any>[];
    selectedItems?: Set<string>;
}

export const LibraryQueueList = ({
                                     handleDeselectAll,
                                     handleRemoveFromQueue,
                                     handleSelectAll,
                                     handleSelectedItemsChange,
                                     handleViewOrder,
                                     heading = "Pending",
                                     queue,
                                     selectedItems,
                                 }: LibraryQueueListProps) => {
    const isQueueEmpty = isArrayNullOrEmpty(queue);

    return <>
        <header>
            <h2>{heading}</h2>
        </header>
        {
            !isQueueEmpty && handleSelectAll && handleDeselectAll &&
            <>
                <ButtonLinkStyle isCollapsed onClick={handleSelectAll} name={`btnSelectAll`} label={`Select All`} /> /&nbsp;
                <ButtonLinkStyle isCollapsed onClick={handleDeselectAll} name={`btnDeselectAll`} label={`Deselect All`} />
            </>
        }
        {
            !isQueueEmpty && queue &&
            queue.map((queuedItem: Record<string, any>) => {
                const {catalogItem, queueItemId, orderStatus} = queuedItem;
                const queueModel = catalogQueueModel({...catalogItem, ...queuedItem});
                const handleDelete = () => handleRemoveFromQueue(queueItemId, orderStatus);
                const isSelected = selectedItems?.has(queueItemId);
                return (
                    <LibraryQueueItem
                        key={queueItemId}
                        {...queueModel}
                        handleDelete={handleDelete}
                        handleViewOrder={handleViewOrder}
                        handleSelectedItemsChange={handleSelectedItemsChange}
                        isSelected={isSelected}
                        orderStatus={orderStatus}
                        queueItemId={handleViewOrder ? "" : queueItemId}
                    />
                );
            })
        }
        {
            isQueueEmpty &&
            <p className={`text-center`}>No results.</p>
        }
        <br/>
        <br/>
    </>;
};

